export const setLeftSide = (state, value) => {
  state.leftSide = value
}

export const setRightSide = (state, value) => {
  state.rightSide = value
}

// Поиск по Issue
export const filterSearch = (state, value) => {
  state.filterSearch = value || null
}

// Фильтр по ТТ
export const filterPos = (state, value) => {
  state.filter.pos = value
}

// Фильтр по дате
export const setFilterDate = (state, value) => {
  if (value.key) {
    state.filterDate[value.key] = value.value
  }
}

export const setCompletedFilterDate = (state, value) => {
  if (value.key) {
    state.filterCompletedDate[value.key] = value.value
  }
}

// Фильтр установить
export const setFilter = (state, value) => {
  if (value.key && state.filter[value.key]) {
    state.filter[value.key] = value.value
  }
}

// Фильтр добавить
export const addFilter = (state, value) => {
  if (value.key && value.value && state.filter[value.key] && !state.filter[value.key].includes(value.value)) {
    state.filter[value.key].push(value.value)
  }
}

// Фильтр убрать
export const removeFilter = (state, value) => {
  if (value.key && value.value && state.filter[value.key]) {
    const i = state.filter[value.key].indexOf(value.value)
    if (i > -1) {
      state.filter[value.key].splice(i, 1)
    }
  }
}

// Сортування добавити
export const addSorting = (state, value) => {
  if (value.key && value.value) {
    state.sorting.key = value.key
    state.sorting.value = value.value
  }
}

// очистить фильтры по запросам
export const clearFilters = state => {
  for (const k in state.filter) {
    state.filter[k] = []
  }
  state.filterSearch = null
  state.filterDate.from = null
  state.filterDate.to = null
  state.filterCompletedDate.from = null
  state.filterCompletedDate.to = null
}

// Фильтр по orgStructure в Call
export const callOrgStructure = (state, value) => {
  state.call.orgStructure = value
}

// Провайдер
export const setProvider = (state, value) => {
  state.provider = value
}

// начат звонок
export const setCallInProgress = (state, value) => {
  state.callInProgress = value
}

// Статус оператора - позиция
export const setOsPosition = (state, value) => {
  state.osPosition = value
}
// Статус оператора - направление
export const setOsDirection = (state, value) => {
  state.osDirection = value
}
// Статус оператора - состояние
export const setOsExpanded = (state, value) => {
  state.osExpanded = value
}

// Карта
export const mapZoom = (state, value) => {
  state.mapZoom = value
}

// ЗАКАЗЫ
export const orderZoom = (state, value) => {
  state.orderZoom = value
}
export const orderColumns = (state, value) => {
  state.orderColumns = value
}
